<nz-table
  #table
  [nzFrontPagination]="false"
  [nzShowSizeChanger]="true"
  [nzTotal]="tablePagination().total"
  [nzPageSize]="tablePagination().pageSize"
  [nzPageIndex]="tablePagination().pageIndex"
  [nzData]="tableData()"
  [nzShowTotal]="totalTemplate"
  (nzQueryParams)="onQueryParamsChange($event)">
  <thead>
    <tr>
      @for (column of tableColumns(); track $index) {
        @if (column.header.type == ColumnType.CHECKBOX) {
          <th
            [nzShowCheckbox]="column.header.isCheckable"
            [(nzChecked)]="allChecked"
            (nzCheckedChange)="checkAll($event)"></th>
        } 
        @if(column.header.label == 'Akcije'){
          <th
          style="width: 15em!important;"
            [nzShowSort]="column.header.isSortable"
            [nzShowFilter]="false"
            [nzSortFn]="true"
            [nzColumnKey]="column.header.key.toString()">
            {{ column.header.label | translate }}
          </th>
        }
        @else {
          <th
            [nzShowSort]="column.header.isSortable"
            [nzShowFilter]="false"
            [nzSortFn]="true"
            [nzColumnKey]="column.header.key.toString()">
            {{ column.header.label | translate }}
          </th>
        }
      }
    </tr>
  </thead>
  <tbody>
    @for (row of table.data; track $index) {
      <tr >
        @for (column of tableColumns(); track $index) {
          @if(column.header.label == 'Akcije'){
               <td>
                <button (click)="toggleExpand(row)" nz-button class="ml-5">
                  
                    <nz-icon *ngIf="isRowExpanded(row)" nzType="down" nzTheme="outline" />
                    <nz-icon *ngIf="!isRowExpanded(row)" nzType="right" nzTheme="outline" />
                                   
                  
                
                </button>
                
              </td>
          }
          @switch (column.header.type) {
            @case (ColumnType.CHECKBOX) {
              <td
                nzShowCheckbox
                (nzCheckedChange)="checkRowChange(row)"></td>
            }
            @case (ColumnType.LINK) {
              <td>
                <a [routerLink]="column?.linkValue(row)?.path">{{ column?.linkValue(row)?.label }}</a>
              </td>
            }
            @case (ColumnType.DATE) {
              <td>{{ column?.cellValue(row) | date: 'dd.MM.yyyy' }}</td>
            }
            @case (ColumnType.TEMPLATE) {
              <td>
                <ng-container *ngTemplateOutlet="column.template!; context: { row: row }"> </ng-container>
              </td>
            }
            @default {
              <td>{{ column?.cellValue(row) }}</td>
            }
          }
          
        }
      </tr>
      <tr *ngIf="isRowExpanded(row)">
        <td [attr.colspan]="tableColumns().length">
          <ng-container
            *ngComponentOutlet="
              dynamicComponent();
              inputs: { row: row, refreshRequested: refreshFromChild }
            "></ng-container>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
<ng-template
  #totalTemplate
  let-total
  >Ukupno {{ total }}</ng-template
>
